module.exports = __webpack_public_path__ + "img/img_05.690eab49.png";